import { hasTreatmentName } from '../utils/treatment-name'

const privacyhubHome = 'main:privacyHub:home'
const privacyhubHomePage = 'main:privacyHub:home:::'
function secondaryHeader(serverData) {
  return [
    {
      label: 'navigation.account',
      id: 'accountLink',
      panelId: 'account-panel',
      link: '/myaccount/settings/account',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|account_tab',
        link: 'account_tab',
      },
    },
    {
      label: 'navigation.security',
      id: 'securityLink',
      panelId: 'security-panel',
      link: '/myaccount/security',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|security_tab',
        link: 'security_tab',
      },
    },
    {
      label: 'navigation.privacy',
      id: 'privacyLink',
      panelId: 'privacy-sections-panel',
      containerClass: 'subSection-privacy-container',
      link:
        serverData.selectedComponent === 'settings'
          ? '/myaccount/privacy'
          : '#',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|data&privacy_tab',
        link: 'data&privacy_tab',
      },
    },
    {
      label: 'navigation.payments',
      id: 'paymentsLink',
      panelId: 'payments-panel',
      link: '/myaccount/preferences/payments',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|payments_tab',
        link: 'payments_tab',
      },
    },
    {
      label: 'navigation.notification',
      id: 'notificationsLink',
      panelId: 'notification-panel',
      link: '/myaccount/preferences/notifications',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|notifications_tab',
        link: 'notifications_tab',
      },
    },
    {
      label: 'navigation.seller',
      id: 'sellerToolsLink',
      panelId: 'sellerTools-panel',
      link: '/myaccount/profile/seller-tools',
      fptiClickData: {
        pgrp: privacyhubHome,
        page: privacyhubHomePage,
        pglk: 'main:privacyHub:home|sellerTools_tab',
        link: 'sellerTools_tab',
      },
    },
    {
      label:
        serverData && serverData.country === 'GB'
          ? 'navigation.taxDocuments'
          : 'navigation.statementsAndTaxes',
      id: 'statementsAndTaxesLink',
      panelId: 'statementsAndTaxes-panel',
      link: '/myaccount/statements',
      hasElmoTreatment: hasTreatmentName('Trmt_DocCenter_Statements_And_Taxes'),
      fptiClickData: {
        pgrp: 'main:walletweb:statementsandtaxes:Home:',
        page: 'main:walletweb:statementsandtaxes:Home::::',
        pglk: 'main:walletweb:statementsandtaxes:Home|statements&Taxes_tab',
        link: 'statements&taxes_tab',
      },
    },
  ]
}
export default secondaryHeader
